<script setup lang="ts">
import { formatDate, formatTime } from "@/utils/date";
import { IAuftrag } from "../api/useDispositionsplan";
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import { datesDaysDifferent } from "@/utils/date";

defineProps<{
  abholung: IAuftrag["abholung"];
  anlieferung: IAuftrag["anlieferung"];
}>();
</script>

<template>
  <div class="flex items-center justify-between pb-1">
    <div class="flex items-start space-x-4 leading-tight">
      <div>
        <span class="block font-medium tracking-wide text-gray-800">
          {{ abholung.name }}
        </span>
        <span class="block text-sm text-gray-700">
          {{ formatTime(abholung.datum) }}
        </span>
      </div>
      <div class="flex items-center">
        <ArrowRightIcon class="w-5 h-5 text-gray-800" />
      </div>
      <div>
        <span class="block font-medium tracking-wide text-gray-800">
          {{ anlieferung.name }}
        </span>
        <span
          v-if="datesDaysDifferent(abholung.datum, anlieferung.datum)"
          class="block text-sm text-gray-700"
        >
          {{ formatDate(anlieferung.datum) }}
        </span>
      </div>
    </div>
  </div>
</template>
